import { ColorUtil } from '@utils/color-util';
import { queryIframeWindow } from '@utils/query';

const hexToRgb = (hex) => {
	const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	return result
		? {
				red: parseInt(result[1], 16),
				green: parseInt(result[2], 16),
				blue: parseInt(result[3], 16),
				alpha: 1,
			}
		: null;
};

const getRelativeLuminance = ({ red, green, blue }) => {
	const [r, g, b] = [red, green, blue].map((c) => {
		const sRGB = c / 255;
		return sRGB <= 0.03928
			? sRGB / 12.92
			: Math.pow((sRGB + 0.055) / 1.055, 2.4);
	});
	return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

const getContrastRatio = (color1, color2) => {
	const l1 = getRelativeLuminance(color1);
	const l2 = getRelativeLuminance(color2);
	const lighter = Math.max(l1, l2);
	const darker = Math.min(l1, l2);
	return (lighter + 0.05) / (darker + 0.05);
};

export const calcContrastFromHex = (fgHex, bgHex, isLarge = false) => {
	const fg = hexToRgb(fgHex);
	const bg = hexToRgb(bgHex);

	if (!fg || !bg) {
		return null;
	}

	const ratio = getContrastRatio(fg, bg);
	const threshold = isLarge ? 3 : 4.5;

	return {
		ratio: +ratio.toFixed(2),
		largeText: isLarge,
		passesAA: ratio >= threshold,
		isPotential: false,
	};
};

export const isLargeText = (el) => {
	if (!el) {
		return false;
	}

	const { fontSize, fontWeight } = queryIframeWindow().getComputedStyle(el);
	const size = parseFloat(fontSize); // px
	const weight = parseInt(fontWeight, 10);
	const isBold = weight >= 700;
	const threshold = isBold ? 18.66 : 24;

	return size >= threshold;
};

export const checkContrastAA = (el) => {
	const colorCombo = ColorUtil.ColorCombo(el);

	if (colorCombo === null) {
		throw new Error(`Unable to get color combo for an element: ${el.nodeName}`);
	}

	const fg = colorCombo.fg;
	const bg = colorCombo.bg;
	const ratio = fg.contrastRatio(bg);
	const large = isLargeText(el);
	const passesAA = ratio >= (large ? 3 : 4.5);

	return {
		ratio: +ratio.toFixed(2),
		largeText: large,
		passesAA,
		isPotential: colorCombo.hasBGImage || colorCombo.hasGradient,
	};
};
